import { Component, OnInit } from '@angular/core';
import {FormArray, FormControl, ReactiveFormsModule, FormGroup, FormArrayName, Validators} from '@angular/forms';
import { Router, ActivatedRoute,  } from '@angular/router';
import { StudentTestControllerService } from '../services/student-test-controller.service';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core'
import { Location } from '@angular/common';
@Component({
  selector: 'app-vuz-data',
  templateUrl: './vuz-data.component.html',
  styleUrls: ['./vuz-data.component.css']
})
export class VuzDataComponent {
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private studentTest: StudentTestControllerService,
    public translate: TranslateService,
    private _notifications: NotificationsService,
    private location: Location
  ) {}

  form!: FormGroup;

  isEnabled = false;

  list: any;
  oblList: any;

  vuzId: any;
  oblId: any;

  nameRus!: any;
  nameKaz!: any;

  ngOnInit(): void {
    this.route.params.subscribe(params => {this.vuzId = params['id'];});

    this.form = new FormGroup({
      isEnabled: new FormControl(false),
      nameRus: new FormControl('', Validators.required),
      nameKaz: new FormControl('', Validators.required),
      oblId: new FormControl(null, Validators.required),
  });
    this.getInstitute();
  }

  getInstitute(){
    this.studentTest.getInstituteById(this.vuzId)
      .subscribe((res: any) => {
        this.list = res;
        this.form.patchValue({
          isEnabled: res[0].isEnabled,
          nameRus: res[0].nameRus,
          nameKaz: res[0].nameKaz,
          oblId: res[0].oblId
        });
        this.getObl();
      });
  }
  getObl() {
    this.studentTest.findAllOblPOsadForNct()
      .subscribe((res: any) => {
        this.oblList = res;
      });
  }
  updateInstitute() {
    if (this.form.valid) {
      let data
      data = {
        id: this.vuzId,
        nameKaz: this.form.get('nameKaz')?.value ? this.form.get('nameKaz')?.value : this.list[0].nameKaz,
        nameRus: this.form.get('nameRus')?.value ? this.form.get('nameRus')?.value : this.list[0].nameRus,
        oblId: this.form.get('oblId')?.value ? this.form.get('oblId')?.value : this.list[0].oblId,
        isEnabled: this.form.get('isEnabled')?.value
      }
      this.studentTest.updateInstitute(this.vuzId, data)
        .subscribe((res: any) => {
          this.translate.currentLang == 'ru' ? this._notifications.create('Успешно', 'Сохранено', NotificationType.Success, 5000) :
            this._notifications.create('Сәтті', 'Сохранено', NotificationType.Success);
          this.goBack();
        });
    }else {
      const invalidFields: string[] = [];
      const fieldLabels: { [key: string]: string } = {
        oblId: this.translate.currentLang == 'ru' ? 'Область' : 'Облыс',
        code: this.translate.currentLang == 'ru' ? 'Код вуза' : 'ЖОО коды',
        nameKaz: this.translate.currentLang == 'ru' ? 'Наименование на казахском' : 'Қазақша атауы',
        nameRus: this.translate.currentLang == 'ru' ? 'Наименование на русском' : 'Орысша атауы'
      };
      for (const controlName in this.form.controls) {
        const control = this.form.get(controlName);
        if (control?.invalid) {
          invalidFields.push(fieldLabels[controlName] || controlName);
        }else{

        }
      }
      this.form.markAllAsTouched();
      const errorMessage =
        this.translate.currentLang == 'ru'
          ? `Пожалуйста, заполните обязательные поля: ${invalidFields.join(', ')}.`
          : `Барлық міндетті өрістерді толтырыңыз: ${invalidFields.join(', ')}.`;
      this._notifications.create(
        this.translate.currentLang == 'ru' ? 'Предупреждение' : 'Ескерту',
        errorMessage,
        NotificationType.Error,
        5000
      );
    }

    }
  goBack(): void {
    this.location.back();
  }

}
